import React, { memo, forwardRef } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const ChannelHomepageIcon = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 32 32"
    >
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.255859 7.00391C0.255859 6.58969 0.591646 6.25391 1.00586 6.25391H29.0059C29.4201 6.25391 29.7559 6.58969 29.7559 7.00391C29.7559 7.41812 29.4201 7.75391 29.0059 7.75391H1.00586C0.591646 7.75391 0.255859 7.41812 0.255859 7.00391Z"
          fill="#1E1E1E"
        />
        <path
          d="M28 8V23.6C28 24.2365 27.7618 24.8469 27.3378 25.297C26.9138 25.7472 26.3387 26 25.7391 26H4.26087C3.66125 26 3.08619 25.7472 2.6622 25.297C2.2382 24.8469 2 24.2365 2 23.6V8H28Z"
          fill="#66E1FF"
        />
        <path
          d="M3.89474 28H5L21 8H2V25.3333C2 26.0573 2 28 2 28C2 28 3.37776 28 3.89474 28Z"
          fill="#C2F3FF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.06132 1.05936C1.57704 0.543637 2.27651 0.253906 3.00586 0.253906H27.0059C27.7352 0.253906 28.4347 0.543637 28.9504 1.05936C29.4661 1.57509 29.7559 2.27456 29.7559 3.00391V15.0039C29.7559 15.4181 29.4201 15.7539 29.0059 15.7539C28.5917 15.7539 28.2559 15.4181 28.2559 15.0039V3.00391C28.2559 2.67238 28.1242 2.35444 27.8897 2.12002C27.6553 1.8856 27.3374 1.75391 27.0059 1.75391H3.00586C2.67434 1.75391 2.3564 1.8856 2.12198 2.12002C1.88756 2.35444 1.75586 2.67239 1.75586 3.00391V25.0039C1.75586 25.3354 1.88755 25.6534 2.12198 25.8878C2.3564 26.1222 2.67434 26.2539 3.00586 26.2539H11.0059C11.4201 26.2539 11.7559 26.5897 11.7559 27.0039C11.7559 27.4181 11.4201 27.7539 11.0059 27.7539H3.00586C2.27651 27.7539 1.57704 27.4642 1.06132 26.9485C0.545591 26.4327 0.255859 25.7333 0.255859 25.0039V3.00391C0.255859 2.27456 0.545591 1.57509 1.06132 1.05936Z"
          fill="#1E1E1E"
        />
        <path
          d="M15.0137 23.0177L21.0377 17.7457C21.5849 17.2675 22.2869 17.0039 23.0137 17.0039C23.7404 17.0039 24.4425 17.2675 24.9897 17.7457L31.0137 23.0177"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.5312 18.3104C21.5311 18.3105 21.5314 18.3103 21.5312 18.3104L15.5076 23.5821C15.1959 23.8549 14.7221 23.8234 14.4493 23.5117C14.1765 23.2 14.208 22.7261 14.5198 22.4533L20.5437 17.1813C21.2276 16.5836 22.1054 16.2539 23.0137 16.2539C23.9219 16.2539 24.7994 16.5833 25.4832 17.181L31.5076 22.4533C31.8193 22.7261 31.8509 23.2 31.5781 23.5117C31.3053 23.8234 30.8315 23.8549 30.5198 23.5821L24.4961 18.3104C24.4961 18.3104 24.4961 18.3105 24.4961 18.3104C24.0856 17.9517 23.5589 17.7539 23.0137 17.7539C22.4686 17.7539 21.9417 17.9518 21.5312 18.3104Z"
          fill="#1E1E1E"
        />
        <path
          d="M17.0137 22L17.0137 29.0029C17.0137 29.5333 17.2244 30.042 17.5995 30.4171C17.9745 30.7922 18.4832 31.0029 19.0137 31.0029H27.0137C27.5441 31.0029 28.0528 30.7922 28.4279 30.4171C28.803 30.042 29.0137 29.5333 29.0137 29.0029V22"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.0137 21.25C17.4279 21.25 17.7637 21.5858 17.7637 22V29.0029C17.7637 29.3344 17.8954 29.6523 18.1298 29.8867C18.3642 30.1212 18.6821 30.2529 19.0137 30.2529H27.0137C27.3452 30.2529 27.6631 30.1212 27.8976 29.8867C28.132 29.6523 28.2637 29.3344 28.2637 29.0029V22C28.2637 21.5858 28.5995 21.25 29.0137 21.25C29.4279 21.25 29.7637 21.5858 29.7637 22V29.0029C29.7637 29.7322 29.4739 30.4317 28.9582 30.9474C28.4425 31.4631 27.743 31.7529 27.0137 31.7529H19.0137C18.2843 31.7529 17.5849 31.4631 17.0691 30.9474C16.5534 30.4317 16.2637 29.7322 16.2637 29.0029V22C16.2637 21.5858 16.5995 21.25 17.0137 21.25Z"
          fill="#1E1E1E"
        />
        <path
          d="M25.0137 31.0039H21.0137V27.0039C21.0137 26.4735 21.2244 25.9648 21.5995 25.5897C21.9745 25.2146 22.4832 25.0039 23.0137 25.0039C23.5441 25.0039 24.0528 25.2146 24.4279 25.5897C24.803 25.9648 25.0137 26.4735 25.0137 27.0039V31.0039Z"
          fill="#C2F3FF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.0137 25.7539C22.6821 25.7539 22.3642 25.8856 22.1298 26.12C21.8954 26.3544 21.7637 26.6724 21.7637 27.0039V30.2539H24.2637V27.0039C24.2637 26.6724 24.132 26.3544 23.8976 26.12C23.6631 25.8856 23.3452 25.7539 23.0137 25.7539ZM21.0691 25.0594C21.5849 24.5436 22.2843 24.2539 23.0137 24.2539C23.743 24.2539 24.4425 24.5436 24.9582 25.0594C25.4739 25.5751 25.7637 26.2746 25.7637 27.0039V31.0039C25.7637 31.4181 25.4279 31.7539 25.0137 31.7539H21.0137C20.5995 31.7539 20.2637 31.4181 20.2637 31.0039V27.0039C20.2637 26.2746 20.5534 25.5751 21.0691 25.0594Z"
          fill="#1E1E1E"
        />
      </g>
    </SvgIcon>
  ))
);
